import SelectCategory from './SelectCategory';

export default SelectCategory;
